// For the few places that build HTML strings (Leaflet divIcon labels): the
// value is a pilot's own input, so it is escaped rather than trusted.
const ENTITIES = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };

export function escapeHtml(s) {
  return String(s ?? "").replace(/[&<>"']/g, (c) => ENTITIES[c]);
}
